/* ============================================================================
   ANALISIS DE MOROSIDAD — Portal Kennedy
   ---------------------------------------------------------------------------
   El mismo reporte que el Crystal "ANALISIS DE MOROSIDAD CXC-OPCION-KCC":
   se elige una FECHA y un PAIS, y salen los clientes de ese pais con su deuda
   repartida en tramos de 30 dias, con subtotal y porcentajes.

   DOS DECISIONES QUE CONVIENE CONOCER

   1. La antiguedad se cuenta desde el VENCIMIENTO (docduedate), no desde la
      fecha del documento. Una factura a 90 dias emitida hace 100 no lleva 100
      dias de mora: lleva 10.

   2. La fecha de corte no es decorativa: los documentos emitidos DESPUES de
      esa fecha no entran, y lo pagado despues tampoco cuenta como pagado. Asi
      el reporte de una fecha pasada sale igual hoy que entonces.

   Solo administracion, gerencia y contabilidad: son saldos de toda la cartera.

   Prefijo `mor`.
============================================================================ */

var MOR_FECHA='', MOR_PAIS='', MOR_ROWS=[], MOR_PAISES=[], MOR_CARGANDO=false;

// Desde que fecha se cuentan los dias de mora.
//   'venc'  desde el VENCIMIENTO: una factura a 90 dias emitida hace 100
//           lleva 10 de mora. Es el criterio contable.
//   'doc'   desde la EMISION: esa misma lleva 100. Es lo que parece hacer el
//           Crystal, y por eso en clientes con credito a 90 dias el portal
//           amontonaba todo en 1-30.
var MOR_BASE='doc';

// Los 13 tramos del reporte de SAP: doce de 30 dias y el ultimo abierto.
var MOR_TRAMOS=[
  {k:'t1',  t:'1-30',    min:1,   max:30},
  {k:'t2',  t:'31-60',   min:31,  max:60},
  {k:'t3',  t:'61-90',   min:61,  max:90},
  {k:'t4',  t:'91-120',  min:91,  max:120},
  {k:'t5',  t:'121-150', min:121, max:150},
  {k:'t6',  t:'151-180', min:151, max:180},
  {k:'t7',  t:'181-210', min:181, max:210},
  {k:'t8',  t:'211-240', min:211, max:240},
  {k:'t9',  t:'241-270', min:241, max:270},
  {k:'t10', t:'271-300', min:271, max:300},
  {k:'t11', t:'301-330', min:301, max:330},
  {k:'t12', t:'331-360', min:331, max:360},
  {k:'t13', t:'360 +',   min:361, max:999999}
];

function morEsc(s){
  return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;')
    .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}
function morNum(v){ var n=Number(v); return isFinite(n)?n:0; }
function morMon(v){
  var n=morNum(v);
  return n.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});
}
function morRol(){
  try{ return String((typeof CU!=='undefined'&&CU&&CU.rol)||'').toLowerCase(); }
  catch(e){ return ''; }
}
function morUsuario(){
  try{ return String((CU&&(CU.username||String(CU.email||'').split('@')[0]))||'').toLowerCase(); }
  catch(e){ return ''; }
}
// Quien ve la cartera COMPLETA de todos los clientes.
function morVeTodo(){
  return ['admin','administrador','gerencia','contabilidad'].indexOf(morRol())>=0
      || ['contabilidad2','joselyn'].indexOf(morUsuario())>=0;
}
// Entra todo el equipo. Un vendedor ve SOLO sus clientes; el resto, todo.
// Por lista negra, no blanca: un rol nuevo entra por defecto en vez de
// quedarse fuera sin aviso.
function morPuede(){
  return morRol()!=='cliente';
}

// ── Mis clientes, cuando soy vendedor ─────────────────────────────────
// En SAP el codigo puede ser compartido ("LEO/HENRY"). Ese cliente cuenta
// para los dos, asi que el nombre se parte por "/".
var MOR_MINOMBRE=null, MOR_MISCODIGOS=null;

async function morMiNombre(){
  if(MOR_MINOMBRE!==null) return MOR_MINOMBRE;
  MOR_MINOMBRE='';
  var sc=null;
  try{ sc=(CU&&CU.slpcode); }catch(e){}
  if(sc!=null && sc!==''){
    try{
      var r=await q('vendedores','select=slpname&slpcode=eq.'+encodeURIComponent(sc)+'&limit=1');
      if(r&&r[0]&&r[0].slpname) MOR_MINOMBRE=String(r[0].slpname).trim();
    }catch(e){}
  }
  if(!MOR_MINOMBRE){
    try{ MOR_MINOMBRE=String((CU&&(CU.nombre||CU.username))||'').trim(); }catch(e){}
  }
  return MOR_MINOMBRE;
}

function morEsMio(nombreVend){
  var yo=String(MOR_MINOMBRE||'').toUpperCase().trim();
  if(!yo) return false;
  var p=String(nombreVend||'').toUpperCase().split('/');
  for(var i=0;i<p.length;i++){ if(p[i].trim()===yo) return true; }
  return false;
}

async function morMisCodigos(){
  if(MOR_MISCODIGOS!==null) return MOR_MISCODIGOS;
  await morMiNombre();
  try{
    var v=await qAll('vendedores','select=slpcode,slpname') || [];
    MOR_MISCODIGOS=v.filter(function(x){ return morEsMio(x.slpname); })
                    .map(function(x){ return x.slpcode; });
  }catch(e){ MOR_MISCODIGOS=[]; }
  return MOR_MISCODIGOS;
}


/* ══════════════════════════════════════════════════════════════════════════
   PANTALLA
   ══════════════════════════════════════════════════════════════════════════ */

function morInit(){
  var c=document.getElementById('mor-content'); if(!c) return;
  if(!morPuede()){
    c.innerHTML='<div class="card" style="text-align:center;padding:30px;color:var(--text3)">'
      +'Esta pantalla no est\u00e1 disponible para tu usuario.</div>';
    return;
  }
  if(!MOR_FECHA) MOR_FECHA=new Date().toISOString().slice(0,10);
  morPintar();
  if(!MOR_PAISES.length) morCargarPaises();
}

async function morCargarPaises(){
  try{
    // Los paises que de verdad tienen clientes con saldo, no la lista entera.
    var cond='select=country&cardtype=eq.C&order=country';
    if(!morVeTodo()){
      var mios=await morMisCodigos();
      // Sin codigo no hay paises que ofrecer: el aviso sale al consultar.
      if(!mios.length){ MOR_PAISES=[]; return; }
      cond+='&slpcode=in.('+mios.join(',')+')';
    }
    var r=await qAll('clientes', cond) || [];
    var v={};
    r.forEach(function(x){ var p=String(x.country||'').trim(); if(p) v[p]=1; });
    MOR_PAISES=Object.keys(v).sort();
  }catch(e){ MOR_PAISES=[]; }
  var sel=document.getElementById('mor-pais');
  if(sel) sel.innerHTML=morOpcionesPais();
}

// En `clientes` el pais es el CODIGO de dos letras (AW, AG, VE). Se muestra
// el nombre, que es lo que la gente reconoce, pero el valor sigue siendo el
// codigo porque es con lo que se consulta.
//
// El mapa va completo (los 249 de la ISO) y no se apoya en r2Pais: aquel
// solo conoce 48 paises y le faltaban justo los del Caribe, que es donde
// esta media cartera. Salia "AW" en vez de "Aruba".
var MOR_PAISES_NOM={"AD": "Andorra", "AE": "Emiratos Árabes Unidos", "AF": "Afghanistan", "AG": "Antigua y Barbuda", "AI": "Anguila", "AL": "Albania", "AM": "Armenia", "AO": "Angola", "AQ": "Antarctica", "AR": "Argentina", "AS": "American Samoa", "AT": "Austria", "AU": "Australia", "AW": "Aruba", "AX": "Åland Islands", "AZ": "Azerbaijan", "BA": "Bosnia and Herzegovina", "BB": "Barbados", "BD": "Bangladés", "BE": "Bélgica", "BF": "Burkina Faso", "BG": "Bulgaria", "BH": "Bahrain", "BI": "Burundi", "BJ": "Benin", "BL": "San Bartolomé", "BM": "Bermuda", "BN": "Brunei Darussalam", "BO": "Bolivia", "BQ": "Bonaire", "BR": "Brasil", "BS": "Bahamas", "BT": "Bhutan", "BV": "Bouvet Island", "BW": "Botswana", "BY": "Belarus", "BZ": "Belice", "CA": "Canadá", "CC": "Cocos (Keeling) Islands", "CD": "Congo, The Democratic Republic of the", "CF": "Central African Republic", "CG": "Congo", "CH": "Suiza", "CI": "Côte d'Ivoire", "CK": "Cook Islands", "CL": "Chile", "CM": "Cameroon", "CN": "China", "CO": "Colombia", "CR": "Costa Rica", "CU": "Cuba", "CV": "Cabo Verde", "CW": "Curazao", "CX": "Christmas Island", "CY": "Cyprus", "CZ": "Chequia", "DE": "Alemania", "DJ": "Djibouti", "DK": "Dinamarca", "DM": "Dominica", "DO": "República Dominicana", "DZ": "Algeria", "EC": "Ecuador", "EE": "Estonia", "EG": "Egipto", "EH": "Western Sahara", "ER": "Eritrea", "ES": "España", "ET": "Ethiopia", "FI": "Finlandia", "FJ": "Fiji", "FK": "Falkland Islands (Malvinas)", "FM": "Micronesia, Federated States of", "FO": "Faroe Islands", "FR": "Francia", "GA": "Gabon", "GB": "Reino Unido", "GD": "Granada", "GE": "Georgia", "GF": "Guayana Francesa", "GG": "Guernsey", "GH": "Ghana", "GI": "Gibraltar", "GL": "Greenland", "GM": "Gambia", "GN": "Guinea", "GP": "Guadalupe", "GQ": "Equatorial Guinea", "GR": "Grecia", "GS": "South Georgia and the South Sandwich Islands", "GT": "Guatemala", "GU": "Guam", "GW": "Guinea-Bissau", "GY": "Guyana", "HK": "Hong Kong", "HM": "Heard Island and McDonald Islands", "HN": "Honduras", "HR": "Croatia", "HT": "Haití", "HU": "Hungría", "ID": "Indonesia", "IE": "Irlanda", "IL": "Israel", "IM": "Isle of Man", "IN": "India", "IO": "British Indian Ocean Territory", "IQ": "Iraq", "IR": "Iran, Islamic Republic of", "IS": "Iceland", "IT": "Italia", "JE": "Jersey", "JM": "Jamaica", "JO": "Jordania", "JP": "Japón", "KE": "Kenya", "KG": "Kyrgyzstan", "KH": "Cambodia", "KI": "Kiribati", "KM": "Comoros", "KN": "San Cristóbal y Nieves", "KP": "Korea, Democratic People's Republic of", "KR": "Corea del Sur", "KW": "Kuwait", "KY": "Islas Caimán", "KZ": "Kazakhstan", "LA": "Lao People's Democratic Republic", "LB": "Líbano", "LC": "Santa Lucía", "LI": "Liechtenstein", "LK": "Sri Lanka", "LR": "Liberia", "LS": "Lesotho", "LT": "Lithuania", "LU": "Luxembourg", "LV": "Latvia", "LY": "Libya", "MA": "Marruecos", "MC": "Monaco", "MD": "Moldova, Republic of", "ME": "Montenegro", "MF": "San Martín (Francia)", "MG": "Madagascar", "MH": "Marshall Islands", "MK": "North Macedonia", "ML": "Mali", "MM": "Myanmar", "MN": "Mongolia", "MO": "Macao", "MP": "Northern Mariana Islands", "MQ": "Martinica", "MR": "Mauritania", "MS": "Montserrat", "MT": "Malta", "MU": "Mauritius", "MV": "Maldives", "MW": "Malawi", "MX": "México", "MY": "Malasia", "MZ": "Mozambique", "NA": "Namibia", "NC": "New Caledonia", "NE": "Niger", "NF": "Norfolk Island", "NG": "Nigeria", "NI": "Nicaragua", "NL": "Países Bajos", "NO": "Noruega", "NP": "Nepal", "NR": "Nauru", "NU": "Niue", "NZ": "Nueva Zelanda", "OM": "Oman", "PA": "Panamá", "PE": "Perú", "PF": "French Polynesia", "PG": "Papua New Guinea", "PH": "Filipinas", "PK": "Pakistán", "PL": "Polonia", "PM": "Saint Pierre and Miquelon", "PN": "Pitcairn", "PR": "Puerto Rico", "PS": "Palestine, State of", "PT": "Portugal", "PW": "Palau", "PY": "Paraguay", "QA": "Catar", "RE": "Réunion", "RO": "Rumanía", "RS": "Serbia", "RU": "Rusia", "RW": "Rwanda", "SA": "Arabia Saudita", "SB": "Solomon Islands", "SC": "Seychelles", "SD": "Sudan", "SE": "Suecia", "SG": "Singapur", "SH": "Saint Helena, Ascension and Tristan da Cunha", "SI": "Slovenia", "SJ": "Svalbard and Jan Mayen", "SK": "Slovakia", "SL": "Sierra Leone", "SM": "San Marino", "SN": "Senegal", "SO": "Somalia", "SR": "Surinam", "SS": "South Sudan", "ST": "Sao Tome and Principe", "SV": "El Salvador", "SX": "San Martín", "SY": "Syrian Arab Republic", "SZ": "Eswatini", "TC": "Islas Turcas y Caicos", "TD": "Chad", "TF": "French Southern Territories", "TG": "Togo", "TH": "Tailandia", "TJ": "Tajikistan", "TK": "Tokelau", "TL": "Timor-Leste", "TM": "Turkmenistan", "TN": "Tunisia", "TO": "Tonga", "TR": "Turquía", "TT": "Trinidad y Tobago", "TV": "Tuvalu", "TW": "Taiwan, Province of China", "TZ": "Tanzania, United Republic of", "UA": "Ukraine", "UG": "Uganda", "UM": "United States Minor Outlying Islands", "US": "Estados Unidos", "UY": "Uruguay", "UZ": "Uzbekistan", "VA": "Holy See (Vatican City State)", "VC": "San Vicente y las Granadinas", "VE": "Venezuela", "VG": "Islas Vírgenes Británicas", "VI": "Islas Vírgenes de EE.UU.", "VN": "Vietnam", "VU": "Vanuatu", "WF": "Wallis and Futuna", "WS": "Samoa", "YE": "Yemen", "YT": "Mayotte", "ZA": "Sudáfrica", "ZM": "Zambia", "ZW": "Zimbabwe"};

function morNombrePais(cod){
  var c=String(cod||'').trim().toUpperCase();
  if(!c) return '';
  if(MOR_PAISES_NOM[c]) return MOR_PAISES_NOM[c];
  // Si ya viene el nombre escrito en vez del codigo, se respeta.
  if(c.length>2) return String(cod).trim();
  return c;
}

function morOpcionesPais(){
  var lista=MOR_PAISES.map(function(p){ return {cod:p, nom:morNombrePais(p)}; });
  lista.sort(function(a,b){ return a.nom.localeCompare(b.nom,'es'); });
  return '<option value="">Todos los pa\u00edses</option>'
    + lista.map(function(x){
        return '<option value="'+morEsc(x.cod)+'"'+(MOR_PAIS===x.cod?' selected':'')+'>'
          +morEsc(x.nom)+'</option>';
      }).join('');
}

function morPintar(){
  var c=document.getElementById('mor-content'); if(!c) return;
  var h='';

  h+='<div class="card" style="margin-bottom:12px">';
  h+='<div style="display:flex;gap:12px;align-items:flex-end;flex-wrap:wrap">';
  h+='<div><div style="font-size:11px;color:var(--text3);text-transform:uppercase;'
    +'letter-spacing:.04em;font-weight:700;margin-bottom:4px">Al d\u00eda</div>'
    +'<input id="mor-fecha" type="date" class="inp" value="'+morEsc(MOR_FECHA)+'" '
    +'onchange="MOR_FECHA=this.value"></div>';
  h+='<div style="flex:1;min-width:200px"><div style="font-size:11px;color:var(--text3);'
    +'text-transform:uppercase;letter-spacing:.04em;font-weight:700;margin-bottom:4px">Pa\u00eds</div>'
    +'<select id="mor-pais" class="inp" style="width:100%" onchange="MOR_PAIS=this.value">'
    +morOpcionesPais()+'</select></div>';
  h+='<div><div style="font-size:11px;color:var(--text3);text-transform:uppercase;'
    +'letter-spacing:.04em;font-weight:700;margin-bottom:4px">Antig\u00fcedad desde</div>'
    +'<select id="mor-base" class="inp" onchange="MOR_BASE=this.value">'
    +'<option value="doc"'+(MOR_BASE==='doc'?' selected':'')
    +'>Fecha del documento</option>'
    +'<option value="venc"'+(MOR_BASE==='venc'?' selected':'')
    +'>Fecha de vencimiento</option></select></div>';
  h+='<button class="btn btn-p" onclick="morConsultar()">Consultar</button>';
  h+='<button class="btn btn-sm" id="mor-xls" onclick="morExcel()">\ud83d\udcca Excel</button>';
  h+='</div></div>';

  h+='<div id="mor-res"></div>';
  c.innerHTML=h;
  if(MOR_ROWS.length) morRender();
}

async function morConsultar(){
  if(MOR_CARGANDO) return;
  var f=(document.getElementById('mor-fecha')||{}).value||'';
  if(!f){ alert('Elige una fecha.'); return; }
  MOR_FECHA=f;
  MOR_PAIS=(document.getElementById('mor-pais')||{}).value||'';
  MOR_BASE=(document.getElementById('mor-base')||{}).value||MOR_BASE;

  MOR_CARGANDO=true;
  var res=document.getElementById('mor-res');
  if(res) res.innerHTML='<div class="card" style="text-align:center;padding:26px;'
    +'color:var(--text3)">Calculando la cartera\u2026</div>';

  try{
    // Los clientes del pais. Sin pais, todos.
    var cond='select=cardcode,cardname,country&cardtype=eq.C';
    if(MOR_PAIS) cond+='&country=eq.'+encodeURIComponent(MOR_PAIS);

    // Un vendedor solo ve SUS clientes, incluidos los de codigo compartido.
    if(!morVeTodo()){
      var mios=await morMisCodigos();
      if(!mios.length){
        MOR_ROWS=[];
        if(res) res.innerHTML='<div class="card" style="text-align:center;padding:26px;'
          +'color:var(--text3)">No encuentro tu c\u00f3digo de vendedor en SAP. '
          +'Te reconozco como <b>'+morEsc(MOR_MINOMBRE||'(sin nombre)')+'</b>.</div>';
        MOR_CARGANDO=false; return;
      }
      cond+='&slpcode=in.('+mios.join(',')+')';
    }
    var cli=await qAll('clientes', cond) || [];
    var porCode={};
    cli.forEach(function(x){ porCode[x.cardcode]=x; });
    var codes=Object.keys(porCode);
    if(!codes.length){
      MOR_ROWS=[];
      if(res) res.innerHTML='<div class="card" style="text-align:center;padding:26px;'
        +'color:var(--text3)">No hay clientes en ese pa\u00eds.</div>';
      MOR_CARGANDO=false; return;
    }

    // Los documentos de cobro ABIERTOS, con el saldo que SAP ya calculo.
    //
    // No se usa el diario: reconstruir la conciliacion -aplicar los pagos a
    // lo mas viejo- movia importes de tramo y no coincidia con SAP. Aqui los
    // pagos YA estan aplicados por SAP; envejecer es solo mirar la fecha de
    // vencimiento de cada documento.
    var docs=[];
    for(var i=0;i<codes.length;i+=200){
      var lote=codes.slice(i,i+200)
        .map(function(x){ return '"'+String(x).replace(/"/g,'')+'"'; }).join(',');
      var d=await qAll('cxc_abiertos',
        'select=cardcode,cardname,docdate,docduedate,saldo,tipo,docnum'
        +'&cardcode=in.('+lote+')&docdate=lte.'+MOR_FECHA) || [];
      docs=docs.concat(d);
      if(res) res.innerHTML='<div class="card" style="text-align:center;padding:26px;'
        +'color:var(--text3)">Leyendo documentos abiertos\u2026 '
        +Math.min(i+200,codes.length)+'/'+codes.length+'</div>';
    }

    MOR_ROWS=morAgrupar(docs, porCode);
    morRender();
  }catch(e){
    if(res) res.innerHTML='<div class="card" style="color:var(--red);padding:20px">'
      +'No se pudo calcular: '+morEsc(e.message||e)+'</div>';
  }finally{
    MOR_CARGANDO=false;
  }
}

// Reparte el saldo de cada cliente en los tramos.
//
// SIN aplicar creditos a mano: los pagos ya vienen aplicados por SAP, y cada
// documento trae su saldo real. Lo unico que se hace es ponerlo en el tramo
// que le toca segun su fecha de vencimiento. Eso es exactamente lo que hace
// el informe de SAP.
function morAgrupar(docs, porCode){
  var corte=new Date(MOR_FECHA+'T23:59:59').getTime();
  var porCli={};

  (docs||[]).forEach(function(d){
    var saldo=morNum(d.saldo);
    if(Math.abs(saldo)<0.005) return;

    var cc=d.cardcode;
    if(!porCli[cc]){
      var c=porCode[cc]||{};
      porCli[cc]={cardcode:cc, cardname:(d.cardname||c.cardname||cc),
                  pais:(c.country||''), total:0};
      MOR_TRAMOS.forEach(function(t){ porCli[cc][t.k]=0; });
    }
    var r=porCli[cc];
    r.total+=saldo;

    // La fecha de referencia, segun lo elegido arriba.
    var base = (MOR_BASE==='venc')
      ? String(d.docduedate||d.docdate||'').slice(0,10)
      : String(d.docdate||d.docduedate||'').slice(0,10);
    var t=new Date(base+'T00:00:00').getTime();
    var dias=isNaN(t)?0:Math.round((corte-t)/86400000);
    if(dias<1) dias=1;        // lo que aun no vence va al primer tramo

    for(var i=0;i<MOR_TRAMOS.length;i++){
      if(dias<=MOR_TRAMOS[i].max || i===MOR_TRAMOS.length-1){
        r[MOR_TRAMOS[i].k]+=saldo; break;
      }
    }
  });

  var out=[];
  Object.keys(porCli).forEach(function(k){
    // Este analisis es de MOROSIDAD: quien debe a la empresa. Un cliente con
    // saldo a favor no debe nada, asi que no entra ni en la lista ni en los
    // totales.
    if(porCli[k].total>0.005) out.push(porCli[k]);
  });
  // Sin filtro de pais, el informe va PAIS POR PAIS, como el de SAP: por eso
  // se ordena primero por pais y dentro por cliente.
  out.sort(function(a,b){
    var pa=morNombrePais(a.pais), pb=morNombrePais(b.pais);
    if(pa!==pb) return pa.localeCompare(pb,'es');
    return String(a.cardname).localeCompare(String(b.cardname),'es');
  });
  return out;
}

function morRender(){
  var res=document.getElementById('mor-res'); if(!res) return;
  if(!MOR_ROWS.length){
    res.innerHTML='<div class="card" style="text-align:center;padding:26px;color:var(--text3)">'
      +'Sin saldos pendientes con esos filtros.</div>';
    return;
  }

  var tot={total:0};
  MOR_TRAMOS.forEach(function(t){ tot[t.k]=0; });
  MOR_ROWS.forEach(function(r){
    tot.total+=r.total;
    MOR_TRAMOS.forEach(function(t){ tot[t.k]+=r[t.k]; });
  });

  var h='<div class="card" style="padding:0;overflow:hidden">';
  h+='<div style="padding:14px 16px;border-bottom:1px solid var(--border)">'
    +'<div style="font-size:15px;font-weight:700">An\u00e1lisis de morosidad</div>'
    +'<div style="font-size:12.5px;color:var(--text2);margin-top:3px">'
    +'Al d\u00eda <b>'+morEsc(MOR_FECHA.split('-').reverse().join('/'))+'</b>'
    +' \u00b7 Pa\u00eds: <b>'+morEsc(MOR_PAIS?morNombrePais(MOR_PAIS):'Todos')+'</b>'
    +' \u00b7 '+MOR_ROWS.length+' cliente(s)'
    +(morVeTodo()?'':' \u00b7 <b>solo tus clientes</b>')+'</div></div>';

  h+='<div style="overflow-x:auto"><table class="tbl" style="margin:0;min-width:1180px;'
    +'font-size:11.5px">';
  h+='<tr><th style="text-align:left">C\u00f3digo</th><th style="text-align:left">Cliente</th>'
    +'<th style="text-align:right">Total</th>'
    +MOR_TRAMOS.map(function(t){
        return '<th style="text-align:right;white-space:nowrap">'+t.t+'</th>';
      }).join('')+'</tr>';

  function _fila(r){
    return '<tr class="clickable" onclick="morVerCliente(\''
      +String(r.cardcode).replace(/'/g,"\\'")+'\')">'
      +'<td style="white-space:nowrap">'+morEsc(r.cardcode)+'</td>'
      +'<td style="max-width:230px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap" '
      +'title="'+morEsc(r.cardname)+'">'+morEsc(r.cardname)+'</td>'
      +'<td style="text-align:right;font-weight:700'
      +(r.total<0?';color:var(--red)':'')+'">'+morMon(r.total)+'</td>'
      +MOR_TRAMOS.map(function(t){
          var v=r[t.k];
          return '<td style="text-align:right'+(Math.abs(v)<0.005?';color:var(--text3)':'')
            +(v<0?';color:var(--red)':'')+'">'+morMon(v)+'</td>';
        }).join('')
      +'</tr>';
  }

  // Una fila de subtotal, con sus porcentajes debajo, igual que el total.
  function _subtotal(etiqueta, filas){
    var st={total:0};
    MOR_TRAMOS.forEach(function(t){ st[t.k]=0; });
    filas.forEach(function(r){
      st.total+=r.total;
      MOR_TRAMOS.forEach(function(t){ st[t.k]+=r[t.k]; });
    });
    var x='<tr style="font-weight:700;background:var(--bg)">'
      +'<td colspan="2" style="text-align:right">'+morEsc(etiqueta)+'</td>'
      +'<td style="text-align:right">'+morMon(st.total)+'</td>'
      +MOR_TRAMOS.map(function(t){
          return '<td style="text-align:right">'+morMon(st[t.k])+'</td>';
        }).join('')+'</tr>';
    x+='<tr style="background:var(--bg);font-size:10.5px;color:var(--text3)">'
      +'<td colspan="3"></td>'
      +MOR_TRAMOS.map(function(t){
          var p = st.total ? (st[t.k]/st.total*100) : 0;
          return '<td style="text-align:right">'+p.toFixed(2)+' %</td>';
        }).join('')+'</tr>';
    return x;
  }

  if(MOR_PAIS){
    MOR_ROWS.forEach(function(r){ h+=_fila(r); });
  } else {
    // Pais por pais, con su cabecera y su subtotal, como el informe de SAP.
    var paisAct=null, grupo=[];
    MOR_ROWS.forEach(function(r){
      var p=morNombrePais(r.pais) || 'Sin pa\u00eds';
      if(p!==paisAct){
        if(grupo.length) h+=_subtotal('SUBTOTAL '+paisAct, grupo);
        paisAct=p; grupo=[];
        h+='<tr style="background:var(--surface2,#E5E7EB)">'
          +'<td colspan="'+(3+MOR_TRAMOS.length)+'" style="font-weight:700;'
          +'font-size:12.5px;padding:7px 10px">Pa\u00eds: '+morEsc(p)+'</td></tr>';
      }
      grupo.push(r);
      h+=_fila(r);
    });
    if(grupo.length) h+=_subtotal('SUBTOTAL '+paisAct, grupo);
  }

  // Totales con su porcentaje debajo, como el reporte de SAP.
  h+='<tr style="border-top:2px solid var(--border);font-weight:700;'
    +'background:var(--surface2,#F3F4F6)">'
    +'<td colspan="2" style="text-align:right">'
    +(MOR_PAIS?'TOTAL':'GRAN TOTAL')+'</td>'
    +'<td style="text-align:right">'+morMon(tot.total)+'</td>'
    +MOR_TRAMOS.map(function(t){
        return '<td style="text-align:right">'+morMon(tot[t.k])+'</td>';
      }).join('')+'</tr>';
  h+='<tr style="background:var(--surface2,#F3F4F6);font-size:11px;color:var(--text2)">'
    +'<td colspan="3"></td>'
    +MOR_TRAMOS.map(function(t){
        var p = tot.total ? (tot[t.k]/tot.total*100) : 0;
        return '<td style="text-align:right">'+p.toFixed(2)+' %</td>';
      }).join('')+'</tr>';

  h+='</table></div></div>';

  h+='<div style="font-size:11.5px;color:var(--text3);margin-top:10px">'
    +'Los d\u00edas se cuentan desde la <b>'
    +(MOR_BASE==='venc'?'fecha de vencimiento':'fecha del documento')
    +'</b>. '
    +'Los clientes con <b>saldo a favor</b> no aparecen: este an\u00e1lisis es de '
    +'qui\u00e9n debe a la empresa.</div>';

  res.innerHTML=h;
}

function morVerCliente(cc){
  try{ VISTA_ACTUAL=function(){ go('morosidad', document.getElementById('nav-mor')); }; }catch(e){}
  try{ verCliente(cc); }catch(e){}
}


/* ══════════════════════════════════════════════════════════════════════════
   EXCEL
   ══════════════════════════════════════════════════════════════════════════ */

async function morExcel(){
  if(typeof xlsxExport!=='function'){ alert('El generador de Excel no est\u00e1 disponible.'); return; }
  if(!MOR_ROWS.length){ alert('Consulta primero.'); return; }
  var b=document.getElementById('mor-xls');
  var prev=b?b.innerHTML:null;
  if(b){ b.disabled=true; b.textContent='Generando\u2026'; }
  try{
    var cols=[
      {label:'C\u00f3digo', key:'cardcode', width:12},
      {label:'Cliente',     key:'cardname', width:38},
      {label:'Pa\u00eds',   key:'pais',     width:16},
      {label:'Total',       key:'total',    width:14, numFmt:'#,##0.00'}
    ].concat(MOR_TRAMOS.map(function(t){
      return {label:t.t, key:t.k, width:13, numFmt:'#,##0.00'};
    }));
    await xlsxExport({
      filename:'morosidad-'+(MOR_PAIS||'todos').replace(/[^A-Za-z0-9]/g,'')+'-'+MOR_FECHA+'.xlsx',
      titulo:'KENNEDY CENTER CORP. - ANALISIS DE MOROSIDAD',
      subtitulo:'Al d\u00eda '+MOR_FECHA+'   Pa\u00eds: '+(MOR_PAIS?morNombrePais(MOR_PAIS):'Todos')
        +'   '+MOR_ROWS.length+' cliente(s)',
      columns:cols, rows:MOR_ROWS,
      valueFn:function(r,k){
        if(k==='pais') return morNombrePais(r[k]);
        if(k==='cardcode'||k==='cardname') return r[k]||'';
        return morNum(r[k]);
      }
    });
  }catch(e){
    alert('No se pudo generar el Excel: '+(e&&e.message?e.message:e));
  }finally{
    if(b){ b.disabled=false; b.innerHTML=prev; }
  }
}
